import { Component } from '@angular/core';
import { soundpostPaymentEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Payments') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostpayment-form',
    templateUrl: './soundpostpayment.form.component.html'
})
export class soundpostPaymentFormComponent extends BaseFormComponent {
    public record!: soundpostPaymentEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'paymentLines', sectionName: 'Payment Lines', isExpanded: false },
            { sectionKey: 'payments', sectionName: 'Payments', isExpanded: false }
        ]);
    }
}

